<template>
  <div>
    <!--List Tags-->
    <div v-if="localTags.length > 0" v-show="!showTagsForm" @mouseover="showEditTagsLink = true" @mouseout="showEditTagsLink = false">
      <span class="contact-tag" v-for="tag in localTags" :key="tag.id" v-text="tag.tag"></span>
      <a @click="showTagsForm = true" v-show="showEditTagsLink">
        <small>Edit Tags</small>
      </a>
    </div>

    <!--Add Tag Button (if no tags)-->
    <div v-else>
      <a class="button small hollow margin-top-small" @click="showTagsForm = true" v-show="!showTagsForm">Add Tag</a>
    </div>

    <!--Edit Tags Form-->
    <div v-if="showTagsForm">
      <tags :tags="localTags" :disabled="isLoading" @value="updateTags($event)"></tags>
      <a class="button small margin-top-small" @click="showTagsForm = false">Close Tags</a>
    </div>

  </div>
</template>

<script>
import ContactsService from '../../services/ContactsService'
import Tags from './Forms/Tags.vue'

export default {
  components: {
    Tags
  },
  props: {
    contactId: Number,
    tags: Array,
    contact: Object
  },
  data () {
    return {
      isLoading: false,
      localTags: [],
      showTagsForm: false,
      showEditTagsLink: false
    }
  },
  methods: {
    updateTags (tags) {
      this.isLoading = true
      const newIds = tags.map((tag) => tag.id)
      ContactsService.updateTags(this.contactId, null, null, newIds)
        .catch((err) => {
          console.error(err.message)
        })
        .then(() => {
          // emit the event the parent
          this.$emit('change', tags)
          this.isLoading = false
        })
    },
    updateLocalTagsFromProp () {
      this.localTags = Array.from(this.tags || [])
    }
  },
  watch: {
    tags () {
      this.updateLocalTagsFromProp()
    }
  },
  created () {
    this.updateLocalTagsFromProp()
  }
}
</script>
